var map = {
	"./AppGallery_Badge_de.png": 305,
	"./AppGallery_Badge_de.svg": 669,
	"./AppGallery_Badge_en.png": 306,
	"./AppGallery_Badge_en.svg": 670,
	"./AppStore_Deutsch.svg": 302,
	"./AppStore_English.svg": 303,
	"./Header-Image.jpg": 671,
	"./MacOS_wordmark.svg": 470,
	"./MacOS_wordmark_white.svg": 471,
	"./Windows_Logo.svg": 472,
	"./accidentInsuranceLandingPage.png": 672,
	"./account_default.png": 463,
	"./add_new_child.svg": 313,
	"./advisor_navigation_background.jpg": 473,
	"./arrows.svg": 207,
	"./asset-calculation.png": 314,
	"./banner_micro.png": 315,
	"./banner_sticker.png": 316,
	"./bin.svg": 159,
	"./calender_circle.svg": 474,
	"./check.svg": 673,
	"./computer.svg": 208,
	"./error.svg": 674,
	"./finMagic_logo.svg": 298,
	"./fit_personal_advising.png": 475,
	"./fonts/Inter/Inter-Black.woff": 675,
	"./fonts/Inter/Inter-Black.woff2": 676,
	"./fonts/Inter/Inter-BlackItalic.woff": 677,
	"./fonts/Inter/Inter-BlackItalic.woff2": 678,
	"./fonts/Inter/Inter-Bold.woff": 679,
	"./fonts/Inter/Inter-Bold.woff2": 680,
	"./fonts/Inter/Inter-BoldItalic.woff": 681,
	"./fonts/Inter/Inter-BoldItalic.woff2": 682,
	"./fonts/Inter/Inter-ExtraBold.woff": 683,
	"./fonts/Inter/Inter-ExtraBold.woff2": 684,
	"./fonts/Inter/Inter-ExtraBoldItalic.woff": 685,
	"./fonts/Inter/Inter-ExtraBoldItalic.woff2": 686,
	"./fonts/Inter/Inter-ExtraLight-BETA.woff": 687,
	"./fonts/Inter/Inter-ExtraLight-BETA.woff2": 688,
	"./fonts/Inter/Inter-ExtraLightItalic-BETA.woff": 689,
	"./fonts/Inter/Inter-ExtraLightItalic-BETA.woff2": 690,
	"./fonts/Inter/Inter-Italic.woff": 691,
	"./fonts/Inter/Inter-Italic.woff2": 692,
	"./fonts/Inter/Inter-Light-BETA.woff": 693,
	"./fonts/Inter/Inter-Light-BETA.woff2": 694,
	"./fonts/Inter/Inter-LightItalic-BETA.woff": 695,
	"./fonts/Inter/Inter-LightItalic-BETA.woff2": 696,
	"./fonts/Inter/Inter-Medium.woff": 697,
	"./fonts/Inter/Inter-Medium.woff2": 698,
	"./fonts/Inter/Inter-MediumItalic.woff": 699,
	"./fonts/Inter/Inter-MediumItalic.woff2": 700,
	"./fonts/Inter/Inter-Regular.woff": 701,
	"./fonts/Inter/Inter-Regular.woff2": 702,
	"./fonts/Inter/Inter-SemiBold.woff": 703,
	"./fonts/Inter/Inter-SemiBold.woff2": 704,
	"./fonts/Inter/Inter-SemiBoldItalic.woff": 705,
	"./fonts/Inter/Inter-SemiBoldItalic.woff2": 706,
	"./fonts/Inter/Inter-Thin-BETA.woff": 707,
	"./fonts/Inter/Inter-Thin-BETA.woff2": 708,
	"./fonts/Inter/Inter-ThinItalic-BETA.woff": 709,
	"./fonts/Inter/Inter-ThinItalic-BETA.woff2": 710,
	"./fonts/Inter/Inter-italic.var.woff2": 711,
	"./fonts/Inter/Inter-roman.var.woff2": 712,
	"./fonts/Inter/Inter.var.woff2": 713,
	"./fonts/Inter/inter.css": 317,
	"./gJunior/Spark7.svg": 318,
	"./gJunior/activation_george_icon.png": 319,
	"./gJunior/activation_info_icon.png": 715,
	"./gJunior/activation_qr_icon.png": 320,
	"./gJunior/app_icon.svg": 321,
	"./gJunior/checkmark_circle.svg": 209,
	"./gJunior/child_icon_boy.svg": 210,
	"./gJunior/child_icon_girl.svg": 322,
	"./gJunior/clock_icon.svg": 323,
	"./gJunior/document_icon.svg": 324,
	"./gJunior/error_circle.svg": 211,
	"./gJunior/gJunior_Intro.png": 716,
	"./gJunior/gjunior_smart_saving_icon.svg": 325,
	"./gJunior/info_circle.svg": 326,
	"./gJunior/junior_tour_step1.svg": 327,
	"./gJunior/junior_tour_step2.svg": 328,
	"./gJunior/junior_tour_step3.svg": 329,
	"./gJunior/junior_tour_step4.svg": 330,
	"./gJunior/qrcode-appstore.svg": 331,
	"./gJunior/stop_timer.svg": 332,
	"./george-app-icon.png": 333,
	"./george-icons.svg": 717,
	"./george-loading-32.gif": 718,
	"./george-loading-white-32.gif": 719,
	"./george-loading-white.svg": 720,
	"./george-loading.svg": 721,
	"./george-logo-xl.png": 722,
	"./george-logo.png": 723,
	"./georgeIdBannerLogo.svg": 212,
	"./george_app_footer_logo.svg": 160,
	"./google-play-badge_de.png": 304,
	"./google-play-badge_en.png": 270,
	"./google_pay.svg": 334,
	"./hand-money-xl.png": 724,
	"./hand-money.png": 725,
	"./householdInsurance_header_image.png": 335,
	"./icon-bulletlist.png": 336,
	"./icon-chevron-down.svg": 726,
	"./icon-chevron-up.svg": 727,
	"./icon-info.png": 476,
	"./illustration.svg": 267,
	"./illustration_PIN_Kreis.svg": 728,
	"./illustration_george_app.svg": 337,
	"./illustration_george_app_new.svg": 338,
	"./illustration_george_business_app.png": 339,
	"./illustration_gig.svg": 340,
	"./kapitalsparen_256832888.jpg": 341,
	"./magic-xl.png": 729,
	"./magic.png": 730,
	"./no_product_available.svg": 342,
	"./optioPay_header_image.png": 464,
	"./pensionFunds_header_image.jpg": 477,
	"./phone-george.svg": 343,
	"./phone.svg": 161,
	"./plugin-giftcard-xl.png": 731,
	"./plugin-giftcard.png": 732,
	"./plus.svg": 121,
	"./prepaid_a05.png": 733,
	"./prepaid_a06.png": 734,
	"./prepaid_a07.png": 735,
	"./prepaid_a0c.png": 736,
	"./prepaid_b08.png": 737,
	"./prepaid_b09.png": 738,
	"./prepaid_b0a.png": 739,
	"./prepaid_b0b.png": 740,
	"./siD_app_icon.svg": 741,
	"./sid-settings-logo.svg": 742,
	"./smart-sparen-hero-mobil.jpg": 344,
	"./store-error.svg": 345,
	"./store-loading.gif": 743,
	"./switch-to-sid.svg": 478,
	"./tpp_link_default.svg": 744,
	"./tpp_link_xl.svg": 745,
	"./tradingPreferences/alternativeInvestments.svg": 346,
	"./tradingPreferences/bonds.svg": 347,
	"./tradingPreferences/funds.svg": 348,
	"./tradingPreferences/gold.svg": 349,
	"./tradingPreferences/stocks.svg": 162,
	"./tradingPreferences/sustainableProducts.svg": 350,
	"./voucher.svg": 746
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 312
// module chunks = 21